<template>
  <div></div>
</template>

<script>
export default {
  name: 'CollectionPageDefault',
  props: [
    'locale',
    'lang',
    'pageId',
    'categoryId'
  ],
  computed: {
    getMainPage () {
      return this.$store.getters['collection/getCollectionMainPage']
    }
  },
  created () {
    // 메인에 커버 세팅이 되어 있으면 커버로 이동 아니면 메인으로 이동
    const mainType = this.getMainPage && this.getMainPage.cover ? 'collectionCover' : 'collectionMain'
    this.$router.replace({
      name: mainType,
      params: {
        ...this.$route.params
      }
    })
  }
}
</script>